import React, { useState } from 'react';
import MonacoEditor from 'react-monaco-editor';

const ConfigurationEditor = ({ configuration, onChange }) => {
  const handleChange = (newValue) => {
    onChange(newValue);
  };

  const options = {
    selectOnLineNumbers: true,
    colorDecorators: true
  };

  return (
    <div className='builder-flex builder-flex-1 builder-h-full builder-mb-6'>
      <MonacoEditor language='json' theme='vs-dark' onChange={handleChange} options={options} value={configuration} />
    </div>
  );
};

export default ConfigurationEditor;
